export default __webpack_public_path__ + "static/media/chatAddOn.bb0ae8b9.svg";